var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 307 149"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-full_svg__a",
    x1: "0%",
    x2: "93.405%",
    y1: "58.366%",
    y2: "58.366%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#C65950"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "59.665%",
    stopColor: "#F07155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B05B61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-full_svg__b",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "41%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#e07964"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85%",
    stopColor: "#c85d50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9e5157"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-full_svg__c",
    width: "156.3%",
    height: "133%",
    x: "-24.6%",
    y: "-14.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "logo-full_svg__d",
    d: "M82.925 97.163c12.793 13.3 29.917 31.129 29.917 31.129a64.778 64.778 0 0014.007-9.927 57.878 57.878 0 0010.062-12.804l-19.414-18.77c8.386-18.019 2.697-38.942-12.24-50.884-14.189-11.341-17.017-1.191-8.486 30.45L86.494 86.792c-7.163 1.941-8.352 5.398-3.57 10.37z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-full_svg__a)",
    d: "M76.497.423C54.14.471 34.062 10.76 24.31 20.898 10.466 35.29.169 53.068 0 80.498v2.57h24.2c-.49-15.692 3.95-28.361 12.062-38.63 16.65-21.05 47.471-25.347 68.755-8.335 18.406 14.714 22.702 42.723 3.997 62.474l17.937 19.848c19.717-18.354 36.68-68.976-7.26-103.114C105.851 4.558 90.891.456 76.82.423h-.322z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.516 117.918c25.686 25.38 63.404 21.943 86.435.507l-17.937-19.848c-11.771 12.428-36.448 15.192-51.22-1.612-9.538-10.884-7.799-28.108 1.436-37.208 6.44-6.358 18.038-9.287 27.12-2.697l18.992-21.093c-8.898-7.116-19.577-10.51-30.212-10.51-14.787 0-29.487 6.565-39.172 18.807-16.206 20.487-17.865 51.498 4.558 73.654z",
    fill: "url(#logo-full_svg__b)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#logo-full_svg__c)",
    xlinkHref: "#logo-full_svg__d"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M69.371 83.068c1.857 1.862 43.572 45.292 43.572 45.292a64.852 64.852 0 0014.008-9.926 57.88 57.88 0 0010.061-12.805L117.598 86.86c8.386-18.02 2.697-38.943-12.24-50.884-21.283-17.012-52.733-12.75-69.383 8.297l23.263 15.492c6.445-6.35 18.148-9.435 27.12-2.696 8.724 6.552 5.217 17.617-.316 21.588-5.976 4.284-10.412 4.356-16.67 4.41m87.488 49.001c0 9.328-7.538 16.89-16.839 16.89-9.3 0-16.84-7.562-16.84-16.89s7.54-16.89 16.84-16.89 16.84 7.562 16.84 16.89"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M222.801 82c1.857 0 3.563.275 5.118.821a14.97 14.97 0 014.285 2.367l-2.893 4.176c-1.132-.769-2.242-1.375-3.327-1.821-1.085-.445-2.17-.668-3.256-.668-1.083 0-1.897.21-2.441.634-.542.421-.813.946-.813 1.571v.075c0 .407.08.764.236 1.066.158.3.44.573.852.814.41.241.973.47 1.687.687.712.217 1.612.47 2.7.758 1.282.34 2.424.718 3.428 1.141 1.003.422 1.848.929 2.538 1.52a5.786 5.786 0 011.559 2.079c.35.796.526 1.747.526 2.858v.07c0 1.256-.226 2.373-.683 3.348a6.884 6.884 0 01-1.903 2.46c-.816.664-1.788 1.168-2.918 1.521-1.128.347-2.38.523-3.755.523a16.87 16.87 0 01-5.678-.987 14.99 14.99 0 01-5.063-3.028l3.292-3.93c1.157.939 2.344 1.686 3.561 2.24 1.218.555 2.55.83 3.998.83 1.156 0 2.054-.21 2.693-.634.64-.421.959-1.006.959-1.754v-.072c0-.362-.067-.68-.2-.959-.134-.279-.388-.535-.76-.777-.375-.24-.895-.482-1.561-.723-.664-.241-1.528-.495-2.592-.76a42.411 42.411 0 01-3.482-1.067c-1.039-.372-1.921-.846-2.646-1.411a5.793 5.793 0 01-1.686-2.116c-.4-.845-.6-1.893-.6-3.147v-.074c0-1.157.216-2.199.648-3.127a7.123 7.123 0 011.814-2.408c.78-.673 1.708-1.193 2.79-1.556 1.08-.358 2.27-.54 3.573-.54zm-59.873 0l6.57 10.571L176.07 82H182v25h-5.43V90.677l-7.035 10.682h-.143l-6.963-10.574V107H157V82h5.928zm38.156 0L212 107h-5.859l-2.328-5.568H193.04L190.712 107H185l10.915-25h5.169zM257 82v5.07h-7.712V107h-5.576V87.07H236V82h21zm22.82 0v4.893h-13.39v5.072h11.786v4.893H266.43v5.25H280V107h-19V82h18.82zm17.286 0c3.079 0 5.44.844 7.082 2.536 1.39 1.427 2.083 3.332 2.083 5.712v.074c0 2.022-.48 3.672-1.44 4.944-.962 1.276-2.217 2.21-3.766 2.805L307 107h-6.248l-5.206-8.001h-4.2V107H286V82h11.106zm-98.68 6.598l-3.383 8.05h6.767l-3.384-8.05zm98.23-1.635h-5.31v7.214h5.415c1.318 0 2.33-.32 3.037-.967.704-.646 1.058-1.507 1.058-2.584v-.071c0-1.2-.37-2.096-1.11-2.693-.742-.6-1.771-.9-3.09-.9zM177.567 34.29c12.894 0 22.447 9.769 22.447 21.963v.122c0 4.49-1.374 8.675-3.702 12.194l4.299 3.7-5.851 6.615-4.598-4.188c-3.581 2.429-7.94 3.763-12.714 3.763C164.552 78.46 155 68.69 155 56.496v-.121c0-12.194 9.672-22.085 22.566-22.085zm39.176.71v23.46c0 6.092 3.055 8.985 7.726 8.985 4.734 0 7.789-2.772 7.789-8.683V35H244v23.399C244 71.969 236.271 78 224.35 78 212.487 78 205 71.908 205 58.701V35h11.742zM261 35v42h-11V35h11zm45 0v8.398L284.986 67.16H306V77h-37v-8.46l21.015-23.76h-20.297V35H306zm-128.553 9.91c-6.39 0-10.627 5.336-10.627 11.465v.121c0 6.127 4.299 11.527 10.746 11.527 1.493 0 2.925-.303 4.178-.789l-5.79-5.034 5.851-6.675 5.671 5.278c.477-1.334.716-2.73.716-4.246v-.12c0-6.13-4.359-11.528-10.745-11.528z"
  }))));
}
export default SvgLogoFull;